export const formatDateGame = (str) => {
    let arr = str.split(".");
    return arr[0];
}

export const formatCurrency = (str) => {
    // return (localStorage.getItem("currency")==null?'':localStorage.getItem("currency")) + " " + (Number(str).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // return (Number(str).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parseInt(str);
}

export const getBet = (winning) => {
    return winning / 10;
}

export const slugify = (text) => {
    return text.toString().toLowerCase()
        .replace(/\s+/g, '')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
        .replace(/^-+/, '')
        .replace(/-+$/, '');
}

export const formatDateDisplay = (date) => { 
    // let d = new Date(date.replace(/-/g, '/'));
    let d  = new Date(date.replace(/\s+/g, 'T') + ':00');
    // return ("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" +
    //     d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);

    return d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2) + " " 
    + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2) + ":" + ("0" + d.getSeconds()).slice(-2);
}

export const getRemainingTime = (date) => {
    if(typeof date !== 'undefined'){
        // let end = new Date(date.replace(/-/g, '/')).getTime();
        let end = new Date(date.replace(/\s+/g, 'T') + ':00').getTime();
        let now = new Date().getTime();
        return end-now>0?end-now:0;
    }
}

export const  millisToMinutesAndSeconds = (duration) => {
    var milliseconds = parseInt((duration % 1000) / 100),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24),
    days = Math.floor(duration / (1000*60*60*24));

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    if(days>0){
        return days + 'd ' + hours + ":" + minutes + ":" + seconds;
    } else {
        return hours + ":" + minutes + ":" + seconds;
    }
}

export const padNum = (num) => {
    num = parseInt(num);
    num = num.toString();
    // while (num.length < 5) num = "0" + num;
    return num;
}

export const emitPostData = (type, data) => {
    var dataObject = {
        container: window.name
    };
    dataObject[String(type)] = data;
    var target = "*";
    parent.postMessage(JSON.stringify(dataObject), target);
};

export const windowResize = (additional) => {
    setTimeout(function () {
        var event;
        if (document.createEvent) {
            event = document.createEvent('HTMLEvents');
            event.initEvent('resize', true, true);
        } else if (document.createEventObject) {
            // IE < 9
            event = document.createEventObject();
            event.eventType = 'resize';
        }
        event.eventName = 'resize';
        if (window.dispatchEvent) {
            window.dispatchEvent(event);
        } else if (window.fireEvent && htmlEvents['onresize']) {
            // IE < 9
            window.fireEvent('on' + event.eventType, resizeEvent);   // can trigger only real event (e.g. 'click')
        } else if (window['resize']) {
            window['resize']();
        } else if (window['onresize']) {
            window['onresize']();
        }
        var html = document.documentElement;
        var doc_height = html.offsetHeight; //Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
        doc_height = doc_height + (typeof additional !== 'undefined'?additional:0);

        var screen_width = (window.innerWidth > 0) ? window.innerWidth : screen.width;

        if(screen_width<1100 && screen_width> 600){

            doc_height += 500;
        }

        var stylingObj = {
            height: doc_height<500?500:doc_height
        };
        emitPostData('style', stylingObj);
    }, 150);
};

export const loginRequest = () => {
    emitPostData('sourceParam', 'customer');
}

export const receiveMessage = (event) => {
    if (typeof event.data.client_token !== "undefined") {
        localStorage.setItem("client_token", event.data.client_token);
    }
    if (typeof event.data.customer !== "undefined") {
        localStorage.setItem("customer", event.data.customer);
    }
    if (typeof event.data.account !== "undefined") {
        localStorage.setItem("account", event.data.account);
    }
    if (typeof event.data.currency !== "undefined") {
        localStorage.setItem("currency", event.data.currency);
    }
}

export const scrollView = () => {
    var scrollObj = {
        position: {
            point: 0
        },
        y: 0
    };
    emitPostData('scroll', scrollObj);
};

export const getUrlParamQueries = () =>{
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}



// WEBPACK FOOTER //
// ./utils/index.js